import _get from "lodash/get";
import _map from "lodash/map";
import * as ActionTypes from "services/state/action-types";

const DOCUMENTS_INITIAL_STATE = {
  loading: false,
  error: false,
  documentsList: [],
  pdfUrlDownloader: null,
};

const documentsListResultAdapter = (documentsList) => {
  return _map(documentsList, (document) => {
    return {
      ...document,
      customerDocumentType: document.documentType,
      intId: document.id,
      name: document.fileName,
      path: document.fileLocation,
      urlWebdav: document.fileUrl,
    };
  });
};

export const documents = (state = DOCUMENTS_INITIAL_STATE, action) => {
  switch (action.type) {
    case ActionTypes.GET_DOCUMENTS:
      return { ...state, loading: true };

    case ActionTypes.GET_DOCUMENTS_SUCCESS:
      const resultData = _get(action, "payload.data", []);
      const documentsList = documentsListResultAdapter(resultData);
      return { ...state, loading: false, documentsList };

    case ActionTypes.GET_DOCUMENTS_FAIL:
      return { ...state, loading: false, error: true };

    case ActionTypes.DOWNLOAD_DOCUMENTS:
      return { ...state, loading: true };

    case ActionTypes.DOWNLOAD_DOCUMENTS_SUCCESS:
      return { ...state, loading: false, pdfUrlDownloader: action.payload };

    case ActionTypes.DOWNLOAD_DOCUMENTS_FAIL:
      return { ...state, loading: false, error: true };

    case ActionTypes.SEND_DOCUMENTS_BY_EMAIL:
      return { ...state, loading: true };

    case ActionTypes.SEND_DOCUMENTS_BY_EMAIL_SUCCESS:
      return { ...state, loading: false };

    case ActionTypes.SEND_DOCUMENTS_BY_EMAIL_FAIL:
      return { ...state, loading: false, error: true };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/services/state/documents/reducer.js